<template>
	<div>
		<div class="banner"><img src="../../assets/i_banner_vdzls.jpg"></div>
		<div class="content">
			<div class="line">
				<span><em>*</em>目的地</span>
				<input type="text" placeholder="请输入您要游玩的地区城市名称" ref="endCity">
			</div>
			<div class="line">
				<span><em>*</em>联系人</span>
				<template v-if="nickname">
					<input type="text" :value="nickname" placeholder="请输入联系人姓名" ref="contacts">
				</template>
				<template v-else>
					<input type="text" placeholder="请输入联系人姓名" ref="contacts">
				</template>
			</div>
			<div class="line">
				<span><em>*</em>手机号码</span>
				<template v-if="mobile">
					<input type="text" :value="mobile" placeholder="请输入联系人手机号" ref="phone">
				</template>
				<template v-else>
					<input type="text" placeholder="请输入联系人手机号" ref="phone">
				</template>
			</div>
			<div class="line">
				<span>出发地</span>
				<input type="text" placeholder="请输入您的出发地" ref="startCity">
			</div>
			
			<div class="line">
				<span>游玩天数</span>
				<input type="text" placeholder="请输入您要游玩的天数" ref="playDays">
			</div>
			<div class="line">
				<span>行程预算</span>
				<input type="text" placeholder="请输入您此行的大概预算" ref="price">
			</div>
			
			
		</div>
		<!-- <div class="kefu" @click="goKefu"><img src="../../assets/i_btn_vcuse.png"></div> -->
		<div class="bottom" @click="submit">提交出游信息</div>
	</div>
</template>

<script>
	export default{
		data() {
			return {
				nickname:'',
				mobile:''
			};
		},
		mounted(){
			this.getInfo();
		},
		methods: {
			getInfo(){
				this.nickname = localStorage.getItem('nickname');
				this.mobile = localStorage.getItem('mobile');
			},
			// 在线客服
			// goKefu(){
			// 	if(this.device === 'android'){
			// 		window.ahatripApp.appGoKeFu(123);
			// 	}else if(this.device === 'ios'){
			// 		window.webkit.messageHandlers.appGoKeFu.postMessage(123);
			// 	}else{
			// 		window.location.href = 'tel://' + 13321109615
			// 	}
			// },
			// 提交信息
			submit(){
				let that = this;
				let endCity = that.$refs.endCity.value;
				let contacts = that.$refs.contacts.value;
				let phone = that.$refs.phone.value;
				let startCity
				if(that.$refs.startCity.value){
					startCity = that.$refs.startCity.value;
				}else{
					startCity = '无';
				}
				let playDays;
				if(that.$refs.playDays.value){
					playDays = that.$refs.playDays.value;
				}else{
					playDays = '无';
				}
				let price;
				if(that.$refs.price.value){
					price = that.$refs.price.value;
				}else{
					price = '无';
				}
				console.log(startCity+'~~~'+endCity+'~~~'+playDays+'~~~'+price+'~~~'+contacts+'~~~'+phone)
				that.$ahaPost("/phone.php?m=line&a=customLine",{
					startCity:startCity,
					endCity:endCity,
					totalDay:playDays,
					price:price,
					linkman:contacts,
					mobile:phone,
				}).then(res => {
					if(res.code==1000){
						console.log(res);
						that.$dialog({ 
							title: '提交成功',
							message: '客服专员将尽快与您联系，请保持手机畅通' ,
							confirmButtonColor:'#5f6b80',
						}).then(() => {
							that.$router.push({
								path:"/vip/vipCard/"
							});
						})
						that.$refs.startCity.value = '';
						that.$refs.endCity.value = '';
						that.$refs.playDays.value = '';
						that.$refs.price.value = '';
						that.$refs.contacts.value = '';
						that.$refs.phone.value = '';
					}else{
						console.log(res);
					}
				}).catch(res => {
						console.log(res)
						if(that.$refs.endCity.value == ''){
							that.$toast('请输入您要游玩的地区城市名称');
						}else if(that.$refs.contacts.value == ''){
							that.$toast('请输入联系人姓名');
						}else if(that.$refs.phone.value == ''){
							that.$toast('请输入联系人手机号');
						}
					}
				);
			},
		},
	}
</script>

<style scoped>
	input::placeholder {
		color: #848689;
	}
	img{
		width: 100%;
	}
	.content{
		margin: 0 25px;
	}
	.line{
		display: flex;
		align-items: center;
		font-size: 15px;
		color: #848689;
		margin-top: 10px;
	}
	.line em{
		color: #ff6600;
		margin-right: 3px;
	}
	.line span{
		width: 80px;
		margin-right: 10px;
		color: #232326;
		padding-bottom: 10px;
	}
	.line input{
		outline: none;
		-webkit-appearance: none;
		flex: 1;
		border-radius:0;
		padding-bottom: 10px;
		line-height: 30px;
		border: none;
		border-bottom: 1.1px solid #e1e1e1;
		color: #232326;
	}
	.kefu{
		position: fixed;
		width: 70px;
		right: 25px;
		bottom: 50px;
	}
	.bottom{
		background: #F17402;
		border-radius: 20px;
		color: #fff;
		font-size: 15px;
		height: 40px;
		line-height: 40px;
		/* position: fixed;
		left: 25px;
		right: 25px;
		bottom: 10px; */
		margin: 20px;
		text-align: center;
	}
</style>
